import { useEffect, useState } from 'react';
import { ACSApi } from '../../../api';
import { useContainer } from '../../../hooks/useContainer';
import { OrganizationMembersWithBranchDataDto } from '../../../commonTypes/acs';

export interface IMembersQueryParams {
    page: number;
    branchId?: string;
    organizationPolicyId?: string;
    search?: string;
}

const useHttpGetOrganizationMembersOMX = (organizationId: string, query: IMembersQueryParams, membersSize: number) => {
    const acsApi: ACSApi = useContainer(ACSApi);
    const [data, setData] = useState<OrganizationMembersWithBranchDataDto[]>([]);
    const [total, setTotal] = useState<number>(0);
    const [isReady, setIsReady] = useState(false);

    const getMembers = (query: IMembersQueryParams, size: number = membersSize) => {
        setIsReady(false);
        return acsApi.getOrganizationMembersWithBranchData({
            params: { organizationId },
            query: { ...query, size },
            onSuccess: res => {
                setData(res.body.items);
                setTotal(Number(res.body.total));
                setIsReady(true);
            },
        });
    };

    useEffect(() => {
        const { exec, abort } = getMembers(query, membersSize);
        exec();
        return abort;
    }, [query, membersSize, organizationId]);

    return { data, total, getMembers, setData, isReady };
};

export default useHttpGetOrganizationMembersOMX;
